import React, {useEffect}from "react";
import { useParams } from "react-router-dom";
import Encabezado from "./Encabezado/Encabezado";
import ConsultaMateria from "./ConsultaMateria/ConsultaMateria";
import Buscador from "./Buscador/Buscador";
import Contenido from "./Contenido/Contenido";
import PiePagina from "./PiePagina/PiePagina";
import Encuesta from "./Encuesta/Encuesta";
import Inicio from "./Contenido/Inicio/Inicio";
import normatecaStore from "./../stores/normatecaStore";
import Loading from "./Contenido/Loading/Loading";


export default function Normateca(paramNor){
    const paramsM= useParams();
    const { visEnc,openDivLoading,opcMenu,setContenido,menuEncabezado,getInfoEnc,setObtenerMenuLat,setVisMenuP,getInfoMat,setObtenerMenuSup,llamadaBuscador,setBusqueda,loading,setBusquedaAva} =
     normatecaStore((state) =>( { 
        visEnc:state.visEnc,
        openDivLoading: state.openDivLoading,
        opcMenu: state.opcMenu,
        setContenido: state.setContenido,
        menuEncabezado: state.menuEncabezado,
        getInfoEnc: state.getInfoEnc,
        setObtenerMenuLat: state.setObtenerMenuLat,
        setVisMenuP: state.setVisMenuP,
        getInfoMat: state.getInfoMat,
        setObtenerMenuSup: state.setObtenerMenuSup,
        llamadaBuscador:state.llamadaBuscador,
        setBusqueda: state.setBusqueda,
        loading: state.loading,
        setBusquedaAva: state.setBusquedaAva,
     })); 
     let opcParam="";
     const contenidoParam=()=>{
        let separarParam= paramNor.param.split("-");
        let pathname = window.location.pathname;
        let prts=pathname.substring(pathname.lastIndexOf("/")+1);
        let opc= "";
        let separarPrts="";
       /*  if(prts.substring(0,1)==="q"){//vienen de buscador
            opc= prts.substring(0,prts.indexOf("="));
        }
        else{//viene de menu
            opc= prts.substring(0,4);
        } */
        opc= prts.substring(0,prts.indexOf("="));
        separarPrts = prts.substring(prts.indexOf("=")+1).split("_");
        if (separarParam[0].toString()==="Inicio" || separarParam[0].toString()==="masInfo" || separarParam[0].toString()==="busAvaOpc"){
            setContenido(separarParam[0].toString(),"0",separarParam[0].toString()).catch(null);
        }
        else 
        if (opc==="q" || opc==="qa"){
                if(opc==="q"){opcParam="bus"}
                if(opc==="qa"){opcParam="busAva"}
                loading(true);//función de store
                let buscar="%20";
                let buscarCaracMay="%3E";
                let radMostrar="";
                let radOrdenDispo="ranking";
                let radOpcBus=1;
                let marcoNor="";
                let marcoJur="";
                let manuales="";
                let unidEmi="";
                let radUnidAdmEmisor="";
                let radTipoBus="";
                //if (paramNor.param==="bus"){
                    radTipoBus="titulo";
                //}
               /* a - %C3%A1
                A - %C3%81
                e - %C3%A9
                E - %C3%89
                i - %C3%AD
                I - %C3%8D
                o - %C3%B3
                O - %C3%93
                u - %C3%BA
                U - %C3%9A*/
                let buscarAcentosAMin= "%C3%A1";
                let buscarAcentosAMay= "%C3%81";
                let buscarAcentosEMin= "%C3%A9";
                let buscarAcentosEMay= "%C3%89";
                let buscarAcentosIMin= "%C3%AD";
                let buscarAcentosIMay= "%C3%8D";
                let buscarAcentosOMin= "%C3%B3";
                let buscarAcentosOMay= "%C3%93";
                let buscarAcentosUMin= "%C3%BA";
                let buscarAcentosUMay= "%C3%9A";
                let buscarÑMin= "%C3%B1";//ñ
                let buscarÑMay= "%C3%91";//Ñ
                let buscarCarac= "%C2%AC";
                let buscarDiagonal="%7C";
                let txtBusTemp= separarPrts[0].toString().replace(new RegExp(buscar,"g") ," ")
                    .replace(new RegExp(buscarAcentosAMin,"g") ,"á")
                    .replace(new RegExp(buscarAcentosAMay,"g") ,"Á")
                    .replace(new RegExp(buscarAcentosEMin,"g") ,"é")
                    .replace(new RegExp(buscarAcentosEMay,"g") ,"É")
                    .replace(new RegExp(buscarAcentosIMin,"g") ,"í")
                    .replace(new RegExp(buscarAcentosIMay,"g") ,"Í")
                    .replace(new RegExp(buscarAcentosOMin,"g") ,"ó")
                    .replace(new RegExp(buscarAcentosOMay,"g") ,"Ó")
                    .replace(new RegExp(buscarAcentosUMin,"g") ,"ú")
                    .replace(new RegExp(buscarAcentosUMay,"g") ,"Ú")
                    .replace(new RegExp(buscarÑMin,"g") ,"ñ")
                    .replace(new RegExp(buscarÑMay,"g") ,"Ñ")
                    .replace(new RegExp(buscarCarac,"g"),"¬")
                    .replace(new RegExp(buscarCaracMay,"g"),">")
                    .replace(new RegExp(buscarDiagonal,"g"),"/");
                let txtBusTemp2= txtBusTemp.split("¬");
                let paramBusAva;
                if (txtBusTemp2.length>1){
                    paramBusAva= txtBusTemp2[1].toString().split("-");
                    radMostrar=paramBusAva[0].toString();
                    if (paramBusAva[1].toString()===""){
                        radOrdenDispo ="ranking";
                    }
                    else{
                        radOrdenDispo =paramBusAva[1].toString();
                    }
                    radOpcBus= paramBusAva[2].toString()===""? 3 : paramBusAva[2];
                    marcoNor=paramBusAva[3].toString();
                    marcoJur=paramBusAva[7].toString();
                    manuales=paramBusAva[8].toString();
                    unidEmi= paramBusAva[4].toString();
                    radUnidAdmEmisor = paramBusAva[5].toString();
                    if (paramBusAva[6].toString()===""){
                        radTipoBus="cbusqueda";
                    }
                    else{
                        radTipoBus=paramBusAva[6].toString();
                    }
                }
                    let txtBusFinal="";
                    if(txtBusTemp2[0].toString().length>250){
                        txtBusFinal=txtBusTemp2[0].toString().substring(0,249);
                    }
                    else{ txtBusFinal=txtBusTemp2[0].toString(); }
                    llamadaBuscador(txtBusFinal,radMostrar,radOrdenDispo,radOpcBus,marcoNor,unidEmi,radUnidAdmEmisor,radTipoBus,marcoJur,manuales).then(function(data){
                    if(opc==="q"){
                        setBusqueda(txtBusFinal,data).catch(null);  
                    }
                    else{
                        setBusquedaAva(txtBusFinal,data).catch(null);  
                    }
                    setContenido(opcParam,"0",opcParam).catch(null);
                    loading(false);//función de store
                })
            }
            else 
            {
                let menuTemp;
                if (menuEncabezado.length===0){
                    menuTemp= JSON.parse(sessionStorage.getItem('menuEncabezado'));
                }
                else{
                   menuTemp= JSON.parse(JSON.stringify(menuEncabezado)) ;
                }
                let indMenu = menuTemp.findIndex((mm)=>mm.id===separarPrts[0].toString().substring(0,4));
                let separaInds= separarPrts[1].toString().split("-");
                let parametros;
                let parametrosPadre;
                switch(separaInds.length){
                    case 1:
                        parametros= menuTemp[indMenu].nivel2[parseInt(separaInds[0])];
                        break;
                    case 2:
                        parametrosPadre= menuTemp[indMenu].nivel2[parseInt(separaInds[0])];
                        parametros= menuTemp[indMenu].nivel2[parseInt(separaInds[0])].nivel3[parseInt(separaInds[1])];
                        break;
                    case 3:
                        parametrosPadre= menuTemp[indMenu].nivel2[parseInt(separaInds[0])].nivel3[parseInt(separaInds[1])];
                        parametros= menuTemp[indMenu].nivel2[parseInt(separaInds[0])].nivel3[parseInt(separaInds[1])].nivel4[parseInt(separaInds[2])];
                        break;
                }
                if (parametros.tipo==="0400"){
                    setContenido(separarPrts[0].toString(),separarPrts[1].toString(),"menuMat").catch(null);
                    getInfoMat(parametros.id,parametros.idTipo,parametros.tipo,parametrosPadre.nombre,parametros.nombre,parametrosPadre.intro,parametros.intro).catch(null); 
                    setObtenerMenuSup().catch(null);       
                }
                else{
                    setContenido(separarPrts[0].toString(),separarPrts[1].toString(),"menuNav").catch(null);
                    if (separaInds.length===1){
                        getInfoEnc(parametros.id,parametros.idTipo,parametros.tipo,parametros.nombre,"",parametros.intro,"").catch(null); 
                    }
                    else{
                        getInfoEnc(parametros.id,parametros.idTipo,parametros.tipo,parametrosPadre.nombre,parametros.nombre,parametrosPadre.intro,parametros.intro).catch(null); 
                    }
                    setObtenerMenuLat(indMenu).catch(null);
                }
                setVisMenuP("00").catch(null);
            }
    }
     useEffect(() => { contenidoParam();},[paramNor,paramsM.datos]);
    return (
        <>
            <div className="position-rel height-5" style={{zIndex:'1049'}}><Encabezado/></div>
            <div className="position-rel backColor-blue4 height-2-5" style={{zIndex:'1048'}}><ConsultaMateria /></div>
            <div><Buscador/></div>
            <div className="position-rel " style={{zIndex:'200'}}>
                {opcMenu==="Inicio" || paramNor.param==="Inicio"?<Inicio/>:<Contenido/>}</div>
            <div><PiePagina/></div>
            <div className="divPrinEncu" style={{zIndex: visEnc? '1050' : '1047'}}><Encuesta/></div>
            {openDivLoading? <Loading /> : null}
        </>
    )
}